import {Injector, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {SharedModule} from './shared/shared.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {AppComponent} from './app.component';
import {ContentLayoutComponent} from './layouts/content/content-layout.component';
import {FullLayoutComponent} from './layouts/full/full-layout.component';

import {AuthService} from './shared/auth/auth.service';
import {AuthGuard} from './shared/auth/auth-guard.service';

import * as $ from 'jquery';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthServerProvider} from './shared/auth/auth-jwt.service';
import {Principal} from './shared/auth/principal.service';
import {AccountService} from './shared/auth/account.service';
import {JhiAlertService, JhiEventManager} from 'ng-jhipster';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {StateStorageService} from './shared/auth/state-storage.service';
import {AuthInterceptor} from './block/interceptor/auth.interceptor';
import {AgmCoreModule} from '@agm/core';
import {LoadingService} from './block/interceptor/loading.service';
import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandlerInterceptor} from './block/interceptor/errorhandler.interceptor';
import {NotificationInterceptor} from './block/interceptor/notification.interceptor';
import {DeviceDetectorModule} from "ngx-device-detector";
import {BsModalRef, BsModalService, ModalModule} from "ngx-bootstrap";
import {MessageService} from "./MessageService";
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';

@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    ContentLayoutComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'asc-tesseramento' }),
    AppRoutingModule,
    SharedModule,
    ModalModule.forRoot(),
    NgbModule.forRoot(),
    HttpClientModule,
    DeviceDetectorModule.forRoot(),
    SelectDropDownModule,
    NgMultiSelectDropDownModule.forRoot(),
    //AgmCoreModule.forRoot({apiKey: 'AIzaSyCzmnPTjb333dN2vVZqfFxFlJZsAXhsNSc', libraries: ['places']})
    AgmCoreModule.forRoot({apiKey: 'AIzaSyB7S7v5WVgEvftoGM-wDSrXZ4zesBVJpRs', libraries: ['places']})

  ],
  providers: [
    AuthService,
    AuthGuard,
    AuthServerProvider,
    AccountService,
    JhiEventManager,
    LocalStorageService,
    SessionStorageService,
    StateStorageService,
    Principal,
    BsModalService,
    LoadingService,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [
        LocalStorageService,
        SessionStorageService,
        LoadingService
      ]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
      deps: [
        JhiEventManager,
        Injector
      ]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true,
      deps: [
        Injector
      ]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts